module.exports = __webpack_public_path__ + "static/img/pic_28.e21c9e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_28.png
// module id = 4C6P
// module chunks = 1